import { AppsRegular, ShieldCheckmarkRegular } from '@fluentui/react-icons'
import { capabilityLayers } from '@/data/capabilities'
import { CapabilityCard } from '@/components/common/CapabilityCard'
import { PanelShell } from './PanelShell'
import grid from './PanelGrid.module.css'

interface PanelProps {
  onOpenWorkspace: () => void
}

export function CapabilitiesPanel({ onOpenWorkspace }: PanelProps) {
  return (
    <PanelShell
      icon={AppsRegular}
      title="Capabilities"
      subtitle="What SOC-Copilot can currently investigate, organized by evidence domain."
      onOpenWorkspace={onOpenWorkspace}
    >
      <div className={grid.phaseBanner}>
        <ShieldCheckmarkRegular style={{ fontSize: 22, color: 'var(--color-brand-secondary)', flexShrink: 0 }} />
        <p className={grid.phaseText}>
          <strong>Current phase: Investigate &amp; Advise.</strong> No automated remediation is
          performed — SOC-Copilot analyzes and recommends, and response actions remain under
          human control.
        </p>
      </div>
      <div className={grid.grid}>
        {capabilityLayers.map((layer) => (
          <CapabilityCard key={layer.id} eyebrow={layer.ordinal} title={layer.title} points={layer.points} />
        ))}
      </div>
    </PanelShell>
  )
}
